import { render, staticRenderFns } from "./store-menu.vue?vue&type=template&id=a32840b0&scoped=true"
import script from "./store-menu.vue?vue&type=script&lang=js"
export * from "./store-menu.vue?vue&type=script&lang=js"
import style0 from "./store-menu.vue?vue&type=style&index=0&id=a32840b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32840b0",
  null
  
)

export default component.exports